import { styled } from '@mui/material/styles';
import { Box, Typography } from "@mui/material";
import Button, { ButtonProps } from '@mui/material/Button';

import { TEXT_PRIMARY } from '../app.styles';
import { blueGrey } from '@mui/material/colors';

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  flex: 1,
  margin: 0,
});

export const StyledShowsBox = styled(Box)(({ theme }) => ({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
  height: 'calc(100% - 160px)',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  margin: '64px 32px',
  [theme.breakpoints.up('sm')]: {
    margin: '64px 32px',
    height: 'calc(100% - 160px)',
  },
  [theme.breakpoints.up('md')]: {
    margin: '64px 64px',
    height: 'calc(100% - 160px)',
  },
  [theme.breakpoints.up('lg')]: {
    margin: '64px 96px',
    height: 'calc(100% - 160px)',
  },
  [theme.breakpoints.up('xl')]: {
    margin: '64px 128px',
    height: 'calc(100% - 256px)',
  },
}));

export const StyledHeaderTypography = styled(Typography)({
  fontSize: '2rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  fontFamily: 'Silka, sans-serif',
  letterSpacing: '0.03rem',
  color: TEXT_PRIMARY,
});

export const StyledShowBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  padding: '20px 0',
  width: '100%',
  columnGap: '24px',
  rowGap: '2px',
  minHeight: '68px',
  borderBottom: `1px solid ${blueGrey[200]}`,
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));

export const StyledShowDateTypography = styled(Typography)({
  fontSize: '0.8rem',
  textTransform: 'uppercase',
  fontFamily: 'Silka, sans-serif',
  letterSpacing: '0.03rem',
  color: TEXT_PRIMARY,
  minWidth: '88px',
});

export const StyledShowLocationTypography = styled(Typography)({
  fontSize: '0.9rem',
  fontWeight: 600,
  fontFamily: 'Silka, sans-serif',
  color: TEXT_PRIMARY,
});

export const StyledShowVenueTypography = styled(Typography)({
  fontSize: '0.9rem',
  textTransform: 'uppercase',
  fontFamily: 'Silka, sans-serif',
  color: TEXT_PRIMARY,
});

export const StyledShowArtistsTypography = styled(Typography)({
  fontSize: '0.8rem',
  fontFamily: 'Silka, sans-serif',
  color: blueGrey[600],
});

export const StyledButton = styled(Button)<ButtonProps<'a'>>(({ theme }) => ({
  fontWeight: 400,
  textTransform: 'uppercase',
  backgroundColor: TEXT_PRIMARY,
  '&:hover': {
    backgroundColor: blueGrey[600],
  },
  fontFamily: 'Silka, sans-serif',
  letterSpacing: '0.03rem',
  marginTop: '8px',
  marginLeft: 0,
  [theme.breakpoints.up('md')]: {
    marginLeft: 'auto',
  },
}));

export const StyledNoShowsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  color: blueGrey[600],
  fontSize: '1.05rem',
});
